import { paths } from '@luxuryescapes/contract-svc-merchandise'
import requestUtils from 'api/requestUtils'
import mapMerchandiseOffer from './mapMerchandiseOffer'

type Response = paths['/api/merchandise/adverts/{id}']['get']['responses']['200']['content']['application/json']

function getMerchandiseById(merchandiseId: string): Promise<App.MerchandiseOffer> {
  return requestUtils.get<Response>(
    `/api/merchandise/adverts/${merchandiseId}`,
  ).then((response): App.MerchandiseOffer => {
    if (!response.result.advert) {
      throw new Error('Merchandise advert not found')
    }

    return mapMerchandiseOffer(response.result.advert)
  })
}

export default getMerchandiseById
